import axios from "axios";
import { jwtDecode } from "jwt-decode";

// The one place that knows the API host. Call sites pass paths only.
//
// The default is unchanged; the env var exists so a local backend can be
// pointed at without editing this file and risking that edit being committed.
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api.medstown.com",
});

instance.defaults.headers.common["Authorization"] = "AUTH TOKEN FROM INSTANCE";

/**
 * Identify the signed-in admin on every request.
 *
 * The backend records these on audit rows and on refund attribution. No
 * /admin route is authenticated yet, so this is an assertion rather than
 * proof — but it means "who did this" is answerable today, and it is the
 * single place to swap in a real token when auth arrives.
 */
instance.interceptors.request.use((config) => {
  try {
    // Sign-in stores a JWT whose payload is `{ email }` — that is the only
    // identity the admin login issues today.
    const token = localStorage.getItem("token");
    if (token) {
      const { email } = jwtDecode(token);
      if (email) {
        config.headers["x-admin-email"] = email;
        config.headers["x-admin-name"] = email;
      }
    }
  } catch (err) {
    // An expired or malformed token must never stop a request going out —
    // the endpoint decides what to do about it, not this interceptor.
  }
  return config;
});

export default instance;
